import React from 'react';

export default function StopIcon({as = React.Fragment, Tag = as, ...props}) {
  return (
    <Tag {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="icon-stop"><circle cx="12" cy="12" r="10" className="primary"/><rect width="7" height="7" x="8.5" y="8.5" className="secondary" rx="1"/></svg>
    </Tag>
  )
};
